// Centralized RTK Query cache tag sets and helpers for work-order-affecting mutations.
// Backend WO generation can continue after the HTTP response returns, so the delayed
// helpers schedule follow-up invalidations to catch WOs that materialize asynchronously.
import {
  CACHE_TAG_ROUTES,
  CACHE_TAG_ROUTES_GEOJSON,
  CACHE_TAG_ROUTES_METADATA,
  CACHE_TAG_ROUTES_METADATA_BY_DATE,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
  CACHE_TAG_WORK_ORDER_COUNT,
  CACHE_TAG_WORK_ORDER_DETAILS,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_CS_SECTION,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY_CS_SECTION,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY_WO_SECTION,
  CACHE_TAG_WORK_ORDER_LIST_WO_SECTION,
} from 'api/cacheTagTypes'

export const WORK_ORDER_CACHE_INVALIDATION_TAGS = [
  CACHE_TAG_ROUTES,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTES_GEOJSON,
  CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
  CACHE_TAG_ROUTES_METADATA,
  CACHE_TAG_ROUTES_METADATA_BY_DATE,
  CACHE_TAG_WORK_ORDER_COUNT,
  CACHE_TAG_WORK_ORDER_DETAILS,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_WO_SECTION,
  CACHE_TAG_WORK_ORDER_LIST_CS_SECTION,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY_WO_SECTION,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY_CS_SECTION,
]

export const DEFAULT_WORK_ORDER_REVALIDATION_DELAYS_MS = [2000, 3000]

export const withDelayedWorkOrderInvalidation =
  ({ api, delaysMs = DEFAULT_WORK_ORDER_REVALIDATION_DELAYS_MS }) =>
  async (arg, { dispatch, queryFulfilled }) => {
    if (arg?.skipWorkOrderInvalidation) {
      queryFulfilled.catch(() => {})
      return
    }
    try {
      await queryFulfilled
      delaysMs.forEach(delayMs => {
        setTimeout(() => {
          dispatch(api.util.invalidateTags(WORK_ORDER_CACHE_INVALIDATION_TAGS))
        }, delayMs)
      })
    } catch {
      // Mutation failed; no delayed invalidation needed.
    }
  }

export const conditionalWorkOrderTags = arg => (arg?.skipWorkOrderInvalidation ? [] : WORK_ORDER_CACHE_INVALIDATION_TAGS)

// Imperative variant for shared mutations (e.g. `moveStops`) where the mutation
// definition stays lean and callers widen the invalidation at the call site.
export const invalidateWorkOrderCacheWithRetry = ({ dispatch, api, delaysMs = DEFAULT_WORK_ORDER_REVALIDATION_DELAYS_MS }) => {
  dispatch(api.util.invalidateTags(WORK_ORDER_CACHE_INVALIDATION_TAGS))
  delaysMs.forEach(delayMs => {
    setTimeout(() => {
      dispatch(api.util.invalidateTags(WORK_ORDER_CACHE_INVALIDATION_TAGS))
    }, delayMs)
  })
}
